import type { ChatParticipant } from '@/types/teacher-chat'
import { getInitials } from '@/utils/chatHelpers'

interface AvatarStackProps {
  participants: ChatParticipant[]
  isActive?: boolean
  size?: 'sm' | 'md'
}

export function AvatarStack({ participants, isActive = false, size = 'sm' }: AvatarStackProps) {
  const dimension = size === 'md' ? 'w-9 h-9 text-xs' : 'w-9 h-9 text-xs'
  const max = 3
  const shown = participants.slice(0, max)
  const extra = participants.length - shown.length

  return (
    <div className="relative shrink-0 flex avatar-stack">
      {shown.map((p, i) => (
        <div
          key={p.teacher_id}
          className={`${dimension} rounded-full flex items-center justify-center text-white font-bold border-2`}
          style={{
            backgroundColor: p.color,
            borderColor: isActive ? '#1e293b' : '#fff',
            zIndex: max - i,
          }}
          title={p.teacher_name}
        >
          {getInitials(p.teacher_name)}
        </div>
      ))}
      {extra > 0 && (
        <div
          className={`${dimension} rounded-full bg-gray-400 flex items-center justify-center text-white font-bold border-2`}
          style={{ borderColor: isActive ? '#1e293b' : '#fff', zIndex: 0 }}
        >
          +{extra}
        </div>
      )}
    </div>
  )
}
